import { Injectable } from '@angular/core';
import Intercom from '@intercom/messenger-js-sdk';

@Injectable({
  providedIn: 'root'
})
export class IntercomService {
  boot(userData: {
    app_id: string;
    user_id?: string;
    name?: string;
    email?: string;
    created_at?: number;
  }) {
    Intercom(userData);
  }

  show() {
    (window as any).Intercom('show');
  }

  hide() {
    (window as any).Intercom('hide');
  }

  update(data: Partial<{
    app_id: string;
    user_id?: string;
    name?: string;
    email?: string;
    created_at?: number;
  }>) {
    (window as any).Intercom('update', data);
  }

  shutdown() {
    (window as any).Intercom('shutdown');
  }
}
